/* eslint react-hooks/exhaustive-deps: "warn" */
import { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { useInt } from 'hooks/useInt';

import { Section } from 'ui/molecules/Section/Section';

import styles from './DataLicensingRedistributionCompliance.module.scss';

type Translate = (key: string) => string;

const getBadges = (t: Translate) => [
  t('GDPR aligned'),
  'SOC 2 Type II',
  'ISO 27001',
  t('Signed DPA on every contract'),
];

const ShieldIcon = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 1.5 2.5 3.5v4c0 3.3 2.3 5.9 5.5 7 3.2-1.1 5.5-3.7 5.5-7v-4z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M5.7 8.1 7.2 9.6l3.1-3.4"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DataLicensingRedistributionCompliance = () => {
  const { t } = useInt();
  const badges = getBadges(t);
  const rootRef = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = rootRef.current;

    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setRevealed(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  return (
    <Section className={styles.root}>
      <div ref={rootRef} className={cn(styles.row, styles.reveal, revealed && styles.revealed)}>
        <p className={styles.text}>
          {t('Every delivery is logged, encrypted in transit, and processed under a signed data processing agreement.')}
        </p>

        <ul className={styles.badges}>
          {badges.map((badge) => (
            <li key={badge} className={styles.badge}>
              <span className={styles.badgeIcon} aria-hidden="true">
                <ShieldIcon />
              </span>
              {badge}
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
};
